import { normalizeApiError } from "helpers/apiError";

export interface CarrierFundingRequestErrorResolution {
  showDuplicateLoadModal: boolean;
  message: string;
  raw: unknown;
}

export const resolveCarrierFundingRequestError = (
  error: unknown
): CarrierFundingRequestErrorResolution => {
  const { message, domain, raw } = normalizeApiError(error);

  return {
    showDuplicateLoadModal: domain === "DUPLICATE_LOAD_NUMBER",
    message,
    raw
  };
};
